import Model from 'src/models/model'

export default class ReportComponent extends Model {
  static name = 'ReportComponent'

  static noId = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.OperationsReporting]

  static define () {
    this.fields = {
      name: {
        type: String,
        output: true
      },
      type: {
        type: String,
        output: true
      },
      deprecated: {
        type: Boolean,
        output: true
      },
      description: {
        type: String,
        output: true
      },
      category: {
        type: String,
        output: true
      }
    }
  }

  get icon () {
    if (this.type === 'Report Table') {
      return 'table_chart'
    } else if (this.type === 'Widget') {
      return 'widgets'
    } else if (this.type === 'Report Chart') {
      return 'addchart'
    } else if (this.type === 'Report View') {
      return 'view_comfy'
    } else {
      return 'question_mark'
    }
  }
}
